module.exports = __webpack_public_path__ + "img/img-basketball-d.beb29cf0.png";